import React from 'react';
import { Link } from 'gatsby';
import { Selector } from './styles';

interface IProps {
  lang: string;
  languages?: Array<any>;
  alternates?: Array<any>;
  country?: string;
}

const LanguageSwitcher = ({ languages, lang, alternates, country }: IProps) =>
  alternates && alternates.length > 1 ? (
    <Selector>
      {alternates.map(({ attributes: language }) => {
        const languageName = languages.filter(value => value.code === language.hreflang)[0].title;
        return (
          <li key={language.hreflang}>
            <Link
              to={language.href}
              className={`language ${language.hreflang === lang ? 'active' : ''}`}
              data-gtm-event
              data-gtm-category="navegacion"
              data-gtm-action={'region'}
              data-gtm-label={`${country}_${languageName}`}>
              {languageName}
            </Link>
          </li>
        );
      })}
    </Selector>
  ) : (
    <></>
  );

export default LanguageSwitcher;
